<div class="app-container">
  <!-- Header Navigation -->
  <header class="main-header">
    <div class="brand-header" (click)="router.navigate(['/home'])" style="cursor: pointer;">
      <img src="/Docsila_logo.png" alt="DocSila" class="brand-logo-header">
    </div>
    
    <div class="header-info">
      <span class="info-item"><strong>Run Title:</strong> {{ runDetail?.documentTitle || 'Untitled Run' }}</span>
      <span class="info-divider">•</span>
      <span class="info-item"><strong>Document:</strong> {{ runDetail?.documentType }}</span>
      <span class="info-divider">•</span>
      <span class="info-item"><strong>Model:</strong> {{ runDetail?.modelName }}</span>
    </div>
    
    <!-- Navigation Buttons in Header -->
    <div class="header-nav-buttons">
      <!-- Role Badge (Admin/User) -->
      @if (authService.isAdmin) {
        <span class="role-badge admin-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      } @else {
        <span class="role-badge user-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      }
    </div>
  </header>

  <!-- Three Column Layout -->
  <main class="content-grid">
    <!-- Column 1: Samples List -->
    <section class="column samples-column">
      <div class="card">
        <div class="samples-header-with-back">
          <button class="btn-back" (click)="backToInferenceList()" title="Back to runs for model" aria-label="Back to runs for model">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back
          </button>
          <h3 class="card-title">{{ runDetail?.documentType }} - Samples ({{ runDetail?.samples?.length || 0 }})</h3>
        </div>
        <div class="samples-list">
          @for (sample of runDetail?.samples; track sample.sampleId) {
            <div class="sample-item" 
                 [class.selected]="selectedSample?.sampleId === sample.sampleId"
                 (click)="selectSample(sample)">
              <div class="sample-header">
                <span class="sample-name">{{ sample.sampleName }}</span>
              </div>
              <div class="sample-range">{{ sample.pageRange }}</div>
            </div>
          }
          @if (!runDetail?.samples?.length) {
            <div class="empty-state">
              <p>No samples available</p>
            </div>
          }
        </div>
      </div>
    </section>

    <!-- Column 2: PDF Viewer -->
    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <h2 class="card-title">Document Preview</h2>
          <div class="viewer-controls-inline">
            <div class="page-controls">
              <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1" title="Previous Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <span class="page-counter">{{ pdfSrc ? currentPage + '/' + totalPages : '0/0' }}</span>
              <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages" title="Next Page">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
            <div class="zoom-controls">
              <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5" title="Zoom Out">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
              <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0" title="Zoom In">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="pdf-container">
          @if (!pdfSrc) {
            <div class="empty-state">
              <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <p>No document loaded</p>
              <p class="empty-subtitle">Select a sample to preview</p>
            </div>
          }

          @if (pdfSrc) {
            <pdf-viewer 
              [src]="pdfSrc" 
              [render-text]="true"
              [original-size]="false"
              [show-all]="false"
              [page]="currentPage"
              [zoom]="zoom"
              (after-load-complete)="onPdfLoadComplete($event)"
              style="width: 100%; height: 100%;"
            ></pdf-viewer>
          }
        </div>
      </div>
    </section>

    <!-- Column 3: Extracted Attributes -->
    <section class="column attributes-column">
      <div class="card">
        <div class="title-with-count">
          <h3 class="card-title">Extracted Attributes</h3>
          @if (selectedSample) {
            <span class="attribute-count">{{ selectedSample.extractedAttributes.length }}</span>
          }
        </div>
        <div class="attributes-feed">
          @if (selectedSample) {
            @for (attr of selectedSample.extractedAttributes; track attr.attributeId) {
              <div class="attribute-card">
                <div class="attribute-header">
                  <div class="attribute-indicator" [class.has-value]="attr.extractedValue">
                    @if (attr.extractedValue) {
                      <span>✓</span>
                    } @else {
                      <span>○</span>
                    }
                  </div>
                  <div class="attribute-label">{{ attr.attributeLabel }}</div>
                  <div class="confidence-badge" [class]="'confidence-' + getConfidenceLevel(attr.confidence)">
                    {{ attr.confidence }}%
                  </div>
                </div>
                <div class="attribute-value">
                  @if (attr.extractedValue) {
                    <div class="value-display">{{ attr.extractedValue }}</div>
                  } @else {
                    <div class="value-empty">No value extracted</div>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="empty-state">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
              <p>Select a sample to view extracted attributes</p>
            </div>
          }
        </div>
      </div>
    </section>
  </main>
</div>
